import { toFrench as hastToFrench } from "@lemonde/hast-util-to-french";

export const name = "italic-between-quotes";

export const transformPastedHTML = (ast) => hastToFrench(ast);
